function fromGQL(obj) {
  const { value, ...returnableField } = obj;
  if (value && value.text) {
    return { ...returnableField, editors: { value: value.text } };
  }
  return { ...returnableField, editors: { value: '' } };
}

function toGQL(opts) {
  return { value: { text: opts.editors.value } };
}

export default {
  fromGQL,
  toGQL,
};
